<template>
  <aside class="text__center_aligment inner_contact">
    <h1 class="text__header_2 spacing__mt_2 text__white">
      {{ $t('contact.title') }}
    </h1>
    <p class="text__subheader spacing__mt_2 text__white">
      {{ $t('contact.subtitle') }}
    </p>
    <KeepMePosted class="spacing__mt_5" />
  </aside>
</template>

<script>
import KeepMePosted from '../components/KeepMePosted'
export default {
  name: 'Contact',
  components: {
    KeepMePosted,
  },
}
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 768px) {
  .inner_contact h1 {
    font-size: 28px;
    line-height: 30px;
  }

  .inner_contact p {
    font-size: 16px;
    line-height: 20px;
  }
}
</style>
